import React from "react";
import SkeletonTable from "../../Common/SkeletonTable";
import ErrorCard from "../../Common/ErrorCard";
import EmptyCard from "../../Common/EmptyCard";

const DHStockTable = ({ stockData, loading, error, onRetry, searchTerm }) => {
  const renderTableContent = () => {
    if (loading) {
      return (
        <SkeletonTable
          columnCount={7}
          rowCount={7}
          headers={[
            "#",
            "Device ID",
            "Device Name",
            "Device Type",
            "Available Stock",
            "Incoming Stock",
            "Outgoing Stock",
          ]}
        />
      );
    }

    if (error) {
      return (
        <ErrorCard
          onRetryClick={onRetry}
          title="Error loading stock data"
          message="Failed to load stock data. Please try again."
        />
      );
    }

    if (stockData.length === 0) {
      return (
        <EmptyCard
          title="No stock data found"
          message={
            searchTerm
              ? "No stock data found matching your search criteria."
              : "No stock data available for this distribution house."
          }
        />
      );
    }

    return (
      <table className="inventory-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Device ID</th>
            <th>Device Name</th>
            <th>Device Type</th>
            <th>Available Stock</th>
            <th>Incoming Stock</th>
            <th>Outgoing Stock</th>
          </tr>
        </thead>
        <tbody>
          {stockData.map((item, index) => (
            <tr key={item.unique_id || index} className="table-row">
              <td>{index + 1}</td>
              <td>{item.unique_id}</td>
              <td title={item.name || ""}>{item.name}</td>
              <td style={{ textTransform: "capitalize" }}>{item.type}</td>
              <td>{item.available_stocks?.toLocaleString() || 0}</td>
              <td>{item.incoming_stocks?.toLocaleString() || 0}</td>
              <td>{item.outgoing_stocks?.toLocaleString() || 0}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return renderTableContent();
};

export default DHStockTable;
